module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/insights-mitchell-truwit.json
// module id = 1393
// module chunks = 55962866542787